import { render, staticRenderFns } from "./ReferencesMenuBtns.vue?vue&type=template&id=6653382a&scoped=true&"
import script from "./ReferencesMenuBtns.vue?vue&type=script&lang=js&"
export * from "./ReferencesMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653382a",
  null
  
)

export default component.exports